<template>
    <v-app style="margin-top:0px;">
        <v-card flat style="border-radius:0px;height:150px;margin-top: 50px;" class="tst res">
            <v-container>
                <h2 style="margin-top:70px;">Financial Assistance</h2>
            </v-container>
        </v-card>
        <v-card flat style="border-radius:0px;height:100px;margin-top:50px" class="tst man">
          <v-container>
              <h2 style="margin-top:10px;">Financial Assistance</h2>
          </v-container>
      </v-card>
  
        <div class="row">
          <div class="col-lg-9 col-md-9 col-sm-12">
        <v-card flat>
        <v-container>
            <div class="row" style="padding-top:20px;">
            <div class="col-lg-6 col-md-6 col-sm-12" style="margin-top:25px;">
              <img  class="img-fluid"  src="https://images.pexels.com/photos/265087/pexels-photo-265087.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" style="height:300px;" />
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12">
                <h2 style="font-weight:500;color:grey;padding-top:20px;">Financial Assistance</h2>
              <p class="txt" style="text-align:justify;">
                The most important part of any admission process is the financial aspect.
                 It is but obvious that education in any ranked university requires financing.
                  Education Loan is an important part of admission for many students especially 
                  in abroad universities as the tuition fee of many universities are high. 
              </p>
              <p class="txt" style="text-align:justify;">
                Our students have received loans from both private and public banking 
                institutions with our guidance and are now completing their education 
                in different parts of the world. 
              </p>
              <p class="txt" style="text-align:justify;">
                Various banks such has Axis Bank, State Bank of India, Bank of Baroda ,
                etc have helped students get the required loan to pursue their education
                in various countries such as Singapore, USA, United Kingdom, Canada,
                New Zealand and Australia.
              </p>
              <!-- <v-btn depressed color="#F12725" dark >Request an Appointment</v-btn> -->
            </div>
            <div class="col-lg-12"><v-divider></v-divider></div>
            

          </div>
          </v-container>
      </v-card>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-12">
            <v-card flat style="background-image: linear-gradient(to right, #f19a28 , #f12525);background-size:cover;margin-top:20px;padding:30px;">
                    <div style="background-color:black;color:white;text-align:center;padding:15px;">
                        <h2>Apply Now</h2>
                    </div>
                    <v-container v-if="otp==false">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <v-layout row wrap >
                                <v-flex xs12 style="padding-top:10px;" >
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;" a-model="form.name" label="Full Name *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.email" label="Email *" :rules="[rules.email]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-text-field outline style="background-color:white;height:70px;border-radius:10px;padding: 15px;"  v-model="form.mobileNumber" label="Mobile No *" :rules="[rules.mobileno]" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCountry"
                                     :items="countries"
                                     color="primary"
                                     label="Preferred Country *"
                                     item-text="countryName"
                                     item-value="countryName"
  
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;">
                                    <v-autocomplete
                                     outline 
                                     style="background-color:white;height:70px;border-radius:10px;padding: 15px;" 
                                     v-model="selectedCourse"
                                     :items="courses"
                                     color="primary"
                                     label="Preferred Course *"
                                     item-text="courses"
                                     item-value="courses"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave" large block dark color="primary" @click="getOtp()">Send Message</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
  
                    <v-container v-if="otp==true">
                        <v-form ref="form1" v-model="valid" lazy-validation>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <label>Enter Your OTP here *</label>
                                    <v-text-field outline style="background-color:white;height:56px" v-model="form1.pin" label="Enter Your OTP here *" :rules="emptyRule" required></v-text-field>
                                </v-flex>
                                <v-flex xs12 style="padding-top:10px;text-align:center;">
                                    <v-btn :loading="btnSave1" large block dark color="primary" @click="onSubmit()">Vefity Now</v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-container>
  
                </v-card>
            </div>
        </div>
  
        <v-dialog v-model="dialog" width="500px" persistent>
           <v-card>
             <div style="height:150px;background-color:green;text-align:center;">
               <div style="padding-top:25px;">
                  <v-icon style="border:1px solid;border-radius:50px;border-color:white;" color="white" :size="80">check</v-icon>
               </div>
             </div>
             <v-container>
               <div style="text-align:center">
                   <h4>Thank You</h4>
                   <h5 class="txt" style="padding-bottom:15px;">Our Counsellors will get back to you !!</h5>
                   <v-btn depressed large color="error" @click="cancel()">Yes Understand</v-btn>
               </div>
             </v-container>
           </v-card>
       </v-dialog>
    </v-app>
  </template>
  
  <script>
  import config from "./../../config.json";
  
  export default {
    components: {
    },
    data() {
      return {
        tab: null,
        valid: true,
        btnSave: false,
        btnSave1: false,
        dialog: false,
        status: false,
        pin: 0,
        otp: false,
        name: [],
  
        ielts: true,
        toefl: false,
        gre: false,
        sat: false,
        gmat: false,
  
        countries: [],
        selectedCountry: null,
  
        courses: ['IELTS', 'TOEFL', 'GRE', 'SAT', 'GMAT'],
        selectedCourse: null,
  
        form: {
          name: null,
          email: null,
          mobileNumber: null
        },
        form1: {
          otp: null
        },
        emptyRule: [v => !!v || "Input is required"],
        rules: {
          required: value => !!value || "Required.",
          email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
          },
          mobileno: value => {
            const pattern = /^[1-9]{1}[0-9]{9}$/;
            return pattern.test(value) || "Mobile number not valid!!";
          },
        },
      };
      
    },
    
     mounted() {
     },
  
   methods: {
     blg(item) {
       sessionStorage.setItem("blogTitle", item.title);
       sessionStorage.setItem("blogDescription", item.description);
       sessionStorage.setItem("blogSrc", item.src);
       this.$router.push("/blogDetail/" + item.id );
     },
  
     getOtp() {
        if (this.$refs.form.validate()) {
          this.btnSave = true;
          this.pin = Math.floor(1000 + Math.random() * 9000);
          this.axios
            .post(
              config.API + 'enquiry/otp',
              {
                name: this.form.name,
                mobileNumber: JSON.parse(this.form.mobileNumber),
                otp: this.pin
              },
              {
                headers: {
                  Authorization: "bearer " + sessionStorage.getItem("token")
                }
              }
            )
            .then(() => {
              this.otp = true;
              this.btnSave = false;
            })
            .catch(() => {
              this.$toaster.error("Mobile number already exists!!");
              this.btnSave = false;
            });
        } else {
          this.$toaster.error(`Required field are empty!!`);
        }
      },
  
      onSubmit() {
        if (this.$refs.form1.validate()) {
          if(this.pin == this.form1.otp) {
            this.btnSave1 = true;
          this.axios
            .post(
              config.API + `enquiry/author`,
              {
                name: this.form.name,
                email: this.form.email,
                mobileNumber: JSON.parse(this.form.mobileNumber),
                country: this.selectedCountry,
                course: this.selectedCourse,
                page: 'Test Preparation',
                date: moment().format('MMMM Do YYYY')
              },
              {
                headers: {
                  Authorization: "bearer " + sessionStorage.getItem("token")
                }
              }
            )
            .then(res => {
              console.log(res);
              this.name = this.form.name.split(' ');
              let firstName = this.name[0];
              let lastName = null;
  
              if(this.name.length > 2) {
                lastName = this.name[1] + this.name[2]
              }
              else {
                lastName = this.name[1]
              }
              this.axios
            .post(
              `http://api.worldwin.org/api/Leads1`,
              {
                firstName: firstName,
                lastName: lastName,
                mobileNumber: JSON.parse(this.form.subject),
                cmsId: JSON.parse(res.data.result.id),
                email: this.form.email,
                guardianName: null,
                guardianNo: 0,
                guardianEmail: null,
                relation: null,
                address: null,
                nature: null,
                source: null,
                document: false,
                documentType: null,
                notes: null,
                levelId: 0,
                leadDetails: null,
                leadTrainings: null
              },
              {
                headers: {
                  Authorization: "bearer " + localStorage.getItem("token")
                }
              }
            )
            .then(res => {
              this.dialog = true;
              this.btnSave1 = false;
            })
            .catch(() => {
              this.$toaster.error(`Mobile no is already registered`);
              this.btnSave = false;
            });
            })
            .catch(() => {
              this.$toaster.error("Mobile no is already registered");
              this.btnSave1 = false;
            });
          }
          else {
            this.$toaster.error("Please put a valied OTP");
          }
        } else {
          this.$toaster.error(`Required field are empty!!`);
        }
      },
  
      cancel() {
          this.$refs.form1.reset();
          this.otp = false;
          this.dialog = false;
      },
   }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
  @import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
  @import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
  </style>
  
  <style scoped>
  .banner {
    background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
    background-size: cover;
    height:200px;
  }
  .tst {
      background-image: linear-gradient(to bottom,rgba(243, 177, 55, 0.73), rgba(58, 18, 18, 0.73)), url('https://www.Worldwininternational.com/images/img19.png');
      background-size: cover;
      color: white !important;
  }
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
  
  .partner {
      margin-top: 15px;
      text-align: center;
      font-size: 23px;
      background-image: linear-gradient(to right, #f19a28 , #f12525);
      border-radius: 0px !important;
      color: whitesmoke !important;
  }
  
  
  .v-card {
    padding: 10px;
    border-radius: 8px;
  }
  .v-sheet--offsets {
    top: -50px;
    position: relative;
  }
  .v-sheet--offset {
    top: -30px;
    position: relative;
  }
  .v-sheet--offsetf {
    top: -100px;
    position: relative;
  }
  .swo {
    box-shadow: none !important;
  }
  .opa {
    opacity: 1;
  }
  div.scroll { 
                  margin:4px, 4px; 
                  padding:4px; 
                  width: auto; 
                  height: 254px; 
                  overflow-x: hidden; 
                  overflow-x: auto; 
                  text-align:justify; 
              }
  .tourtheme {
    height: 180px;
    margin: 5px;
    background-size: cover;
  }
  .themecap {
    font-family: 'Open Sans', sans-serif;
    padding-top: 130px;
    color: white;
  }
  .top-left {
    font-family: 'Roboto Mono', monospace;
    font-size:40px ;
    padding-top: 200px;
    color: white;
    text-align: center;
  }
  .salont {
    font-family: 'Patua One', cursive;
  }
  .link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
  .hvr:hover {
    cursor: pointer;
    border-radius: 5px !important;
    border : 1px solid;
    border-color: black !important;
    transition-duration: 0.7s;
    text-decoration: none !important;
  }
  .v-table tbody tr:not(:last-child) {
      border-bottom: none !important;
  }
  @media screen and (max-width: 768px) {
    .res {
      display: none;
    }
  }
  @media screen and (min-width: 768px){
    .man {
      display: none;
    }
  }
  img.center {
      display: block;
      margin: 0 auto;
  }
  .recent {
    font-family: 'Nanum Gothic', sans-serif;
  }
  .srch {
    position: absolute;
    z-index: 10;
    left: 16%;
    top: 0%;
  }
  .item {
      border:1px solid !important;
  }
  </style>
  